import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0; // Safari

    const root = document.getElementById('root');
    if (root) root.scrollTop = 0;

    const app = document.querySelector('.App');
    if (app) app.scrollTop = 0;
  }, []);

  return (
    <div className="terms-container">
      <style>{`
        .terms-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #f5f7fa 100%);
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          padding: 40px 20px;
        }

        .terms-wrapper {
          max-width: 900px;
          margin: 0 auto;
          background: white;
          border-radius: 24px;
          box-shadow: 0 0 1px rgba(0,0,0,0.1);
          overflow-y: auto;
        }

        /* Header Styles */
        .terms-header {
          background: white;
          color: #333;
          padding: 40px 48px;
          position: relative;
        }

        .back-button {
          position: absolute;
          top: 40px;
          left: 48px;
          background-color: transparent;
          border: none;
          cursor: pointer;
          padding: 8px 12px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .back-button:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateX(-2px);
        }

        .back-button svg {
          width: 12px;
          height: 24px;
          color: white;
        }

        .terms-header h1 {
          font-size: 2.5rem;
          margin-bottom: 12px;
          font-weight: 600;
          text-align: center;
        }

        .last-updated {
          text-align: center;
          opacity: 0.9;
          font-size: 0.9rem;
        }

        /* Content Styles */
        .terms-content {
          padding: 48px;
        }

        .terms-section {
          margin-bottom: 32px;
          padding-bottom: 24px;
          border-bottom: 1px solid #e9ecef;
        }

        .terms-section:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .terms-section h2 {
          color: #2d3748;
          font-size: 1.5rem;
          margin-bottom: 16px;
          font-weight: 600;
        }

        .terms-section h3 {
          color: #4a5568;
          font-size: 1.2rem;
          margin: 16px 0 12px 0;
          font-weight: 500;
        }

        .terms-section h4 {
          color: #2d3748;
          font-size: 1rem;
          margin: 12px 0 8px 0;
          font-weight: 600;
        }

        .terms-section p {
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 16px;
          font-size: 1rem;
        }

        .terms-section ul {
          margin: 12px 0 16px 24px;
          color: #4a5568;
          line-height: 1.7;
        }

        .terms-section li {
          margin-bottom: 8px;
        }

        .highlight {
          background: #fef3c7;
          padding: 12px 16px;
          border: 1px solid #f59e0b;
          border-radius: 8px;
          margin: 16px 0;
          color: #92400e;
        }

        .fee-box {
          background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
          padding: 20px;
          border-radius: 12px;
          margin: 16px 0;
          border: 1px solid #bfdbfe;
        }

        .fee-box p {
          margin-bottom: 12px;
        }

        .fee-box p:last-child {
          margin-bottom: 0;
        }

        .policy-box {
          background: #f8fafc;
          padding: 20px;
          border-radius: 12px;
          margin: 16px 0;
          border: 1px solid #e2e8f0;
        }

        .policy-box h4 {
          margin-top: 12px;
        }

        .policy-box h4:first-child {
          margin-top: 0;
        }

        .final-agreement {
          background: #f0fdf4;
          padding: 24px;
          border-radius: 12px;
          margin-top: 24px;
          border: 1px solid #bbf7d0;
        }

        .final-agreement h2 {
          color: #166534;
          margin-bottom: 12px;
        }

        .final-agreement p {
          color: #14532d;
        }

        .contact-section {
          background: #fef2f2;
          padding: 24px;
          border-radius: 12px;
          margin-top: 24px;
          border: 1px solid #fecaca;
        }

        .contact-section h2 {
          color: #991b1b;
          margin-bottom: 12px;
        }

        .contact-section p {
          color: #7f1d1d;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .terms-container {
            padding: 20px 12px;
          }

          .terms-header {
            padding: 30px 24px;
          }

          .back-button {
            top: 30px;
            left: 24px;
          }

          .terms-header h1 {
            font-size: 1.8rem;
          }

          .terms-content {
            padding: 30px 24px;
          }

          .terms-section h2 {
            font-size: 1.3rem;
          }

          .terms-section p {
            font-size: 0.95rem;
          }

          .fee-box, .policy-box, .final-agreement, .contact-section {
            padding: 16px;
          }
        }

        @media (max-width: 480px) {
          .terms-header h1 {
            font-size: 1.5rem;
          }

          .terms-content {
            padding: 24px 16px;
          }

          .terms-section {
            margin-bottom: 24px;
            padding-bottom: 20px;
          }
        }

        /* Marketing Section Styles */
        .marketing-section {
          background: linear-gradient(135deg, #fefce8 0%, #fef9c3 100%);
          padding: 24px;
          border-radius: 12px;
          margin: 32px 0;
          border: 1px solid #fde047;
        }

        .marketing-section h2 {
          color: #854d0e;
        }

        .marketing-section p {
          color: #422006;
        }

        .marketing-optout-box {
          background: white;
          padding: 20px;
          border-radius: 12px;
          margin: 20px 0;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .marketing-optout-box h4 {
          color: #854d0e;
          font-size: 1.1rem;
          margin-bottom: 12px;
        }

        .marketing-optout-box ul {
          margin: 12px 0 12px 24px;
          color: #422006;
        }

        .marketing-optout-box li {
          margin-bottom: 8px;
        }

        .optout-note {
          background: #fef3c7;
          padding: 12px;
          border-radius: 8px;
          margin-top: 16px;
          font-size: 0.9rem;
        }

        .marketing-section ul {
          margin: 12px 0 16px 24px;
          color: #422006;
        }

        .marketing-section li {
          margin-bottom: 8px;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .marketing-section {
            padding: 16px;
          }

          .marketing-optout-box {
            padding: 16px;
          }

          .optout-note {
            font-size: 0.85rem;
          }
        }
      `}</style>

      <div className="terms-wrapper">
        
        {/* Header with Back Button */}
        <div className="terms-header">
          <button className="back-button" onClick={() => navigate(-1)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24">
              <path fill="currentColor" fillRule="evenodd" d="m3.343 12l7.071 7.071L9 20.485l-7.778-7.778a1 1 0 0 1 0-1.414L9 3.515l1.414 1.414z"/>
            </svg>
          </button>
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last Updated: April 2026</p>
        </div>

        {/* Content Sections */}
        <div className="terms-content">
          
          {/* Platform Role */}
          <section className="terms-section">
            <h2>1. Platform Role</h2>
            <p>MyKaddle operates strictly as a technology platform that facilitates connections between tutors and tutees. Kaddle does not create, supply, verify the accuracy of, or take responsibility for any educational content, materials, sessions, or communications provided by tutors. All teaching materials, files, lesson structures, and instructional quality remain the sole responsibility of the tutor providing them.</p>
            <p>The platform provides tools that enable users to interact, including but not limited to group sessions, messaging systems, file sharing, subscription management, and payment processing integrations. While Kaddle may introduce features such as automation tools, analytics, or AI-assisted support in the future, these tools are intended to assist and do not replace the responsibility of tutors or learners.</p>
            <p className="highlight">Kaddle does not guarantee educational outcomes, academic performance improvements, or the reliability of any tutor. Users engage with tutors at their own discretion and risk.</p>
          </section>

          {/* Accounts and Minors */}
          <section className="terms-section">
            <h2>2. Accounts and Minors</h2>
            <p>Users who are under the age of majority must have their accounts created, managed, and supervised by a parent or legal guardian. The guardian assumes full responsibility for all activity conducted through the minor's account, including financial transactions, communications, and participation in tutoring sessions.</p>
            <p>Kaddle does not independently verify the age of users and relies on users and guardians to provide accurate information. Any misuse of accounts by minors without appropriate supervision may result in account suspension or termination.</p>
            <p>Parents and guardians are expected to actively monitor interactions, ensure appropriate conduct, and manage all payments associated with the account.</p>
          </section>

          {/* Tutor Verification */}
          <section className="terms-section">
            <h2>3. Tutor Verification</h2>
            <p>Kaddle implements a verification process for tutors before allowing them to offer services on the platform. This process may include identity checks, qualification reviews, or other screening methods as determined by Kaddle.</p>
            <p>However, verification does not constitute a guarantee of teaching ability, professionalism, or reliability. Kaddle does not warrant the accuracy of any credentials provided by tutors. Users are encouraged to exercise independent judgment when selecting tutors.</p>
            <p>Kaddle reserves the right to revoke tutor access at any time if concerns arise regarding quality, conduct, or compliance with platform rules.</p>
          </section>

          {/* Marketing Use of Tutor Profiles - NEW SECTION */}
          <section className="terms-section marketing-section">
            <h2>4. Marketing Use of Tutor Profiles</h2>
            <p>By creating a tutor profile on MyKaddle, you grant the platform permission to use your profile information, including but not limited to your name, profile picture, qualifications, bio, subject expertise, and teaching highlights for marketing and promotional purposes.</p>
            <p>This may include featuring tutor profiles on:</p>
            <ul>
              <li>The Kaddle website and landing pages</li>
              <li>Social media channels (Instagram, Facebook, LinkedIn, Twitter/X)</li>
              <li>Email newsletters and promotional campaigns</li>
              <li>Marketing materials and advertisements</li>
              <li>Partner platforms and affiliate marketing channels</li>
            </ul>
            <div className="marketing-optout-box">
              <h4>✋ Opt-Out Option</h4>
              <p>If you do not wish for your profile to be used in marketing materials, you may submit a formal request to:</p>
              <p><strong>📧 support@mykaddle.com</strong></p>
              <p>Upon receiving your opt-out request, Kaddle will:</p>
              <ul>
                <li>Remove your profile from all active marketing campaigns within 14 business days</li>
                <li>Cease using your profile information in future promotional content</li>
                <li>Remove any existing public posts featuring your profile from social media and marketing channels</li>
                <li>Retain your profile only for operational purposes within the platform</li>
              </ul>
              <p className="optout-note"><strong>Note:</strong> Opting out of marketing use does not affect your ability to use the platform as a tutor. Your profile will remain visible to students within the Kaddle platform for discovery and engagement purposes.</p>
            </div>
            <p>Kaddle respects tutor preferences and will honor all valid opt-out requests promptly. However, Kaddle cannot guarantee removal from third-party platforms or cached versions of marketing materials beyond its direct control.</p>
          </section>

          {/* Free Trial Access */}
          <section className="terms-section">
            <h2>5. Free Trial Access</h2>
            <p>New tutees may receive limited free trial access when joining a tutor's group for the first time. This trial period is intended solely for evaluation purposes and allows users to experience group interactions, access shared materials, and assess the suitability of the tutor.</p>
            <p>Once the trial period concludes, continued access to the group and its associated features requires an active paid subscription. Failure to subscribe within the allowed period will result in restricted access or automatic removal from the group.</p>
            <p>Free trials are granted once per tutor group and may not be reused, duplicated, or extended through account manipulation or rejoining attempts. Kaddle reserves the right to revoke trial access in cases of abuse or misuse.</p>
          </section>

          {/* Tutor Control */}
          <section className="terms-section">
            <h2>6. Tutor Control Over Services</h2>
            <p>Tutors retain full control over the structure and delivery of their services, including pricing, billing cycles, session frequency, group size limits, and content distribution. Kaddle does not intervene in pricing decisions or teaching methodologies.</p>
            <p>All agreements regarding session expectations, schedules, and deliverables are established between tutors and tutees. Kaddle acts only as a facilitator and is not responsible for unmet expectations, missed sessions, or dissatisfaction with services.</p>
          </section>

          {/* Platform Conduct */}
          <section className="terms-section">
            <h2>7. Platform Conduct</h2>
            <p>All users are expected to interact respectfully and professionally within the platform. Any form of harassment, discrimination, abusive language, or inappropriate behavior is strictly prohibited.</p>
            <p>Kaddle reserves the right to investigate reports of misconduct and take appropriate action, including temporary suspension, permanent bans, or restricted access to certain features. Decisions regarding enforcement are made at Kaddle's sole discretion.</p>
            <p>Repeated violations or severe misconduct may result in immediate termination without prior notice.</p>
          </section>

          {/* File and Chat Retention */}
          <section className="terms-section">
            <h2>8. File and Chat Retention</h2>
            <p>To maintain system performance, security, and data efficiency, Kaddle enforces automatic deletion policies for certain types of content. Files shared within group chats may be deleted after a defined period, and chat messages may also expire after a set timeframe.</p>
            <p>Users are solely responsible for saving any content they wish to retain. Kaddle does not guarantee the availability, recovery, or backup of deleted files or messages.</p>
            <p>These retention policies may be adjusted over time as the platform evolves.</p>
          </section>

          {/* Support */}
          <section className="terms-section">
            <h2>9. Support</h2>
            <p>Kaddle provides a support system through in-platform tools such as the "Get Help" feature. While the platform aims to respond to all user inquiries in a timely manner, response times are not guaranteed.</p>
            <p>Support services are limited to platform-related issues and do not extend to resolving disputes between users unless explicitly stated. Kaddle may provide guidance but does not act as a mediator in all cases.</p>
          </section>

          {/* Refund Policy */}
          <section className="terms-section">
            <h2>10. Refund Policy</h2>
            <p>Refunds are issued under limited and specific circumstances, such as when a tutor becomes unavailable, is suspended, or fails to provide agreed-upon services over a sustained period.</p>
            <p>Refund amounts, where applicable, are calculated proportionally based on unused subscription time. Kaddle reserves the right to determine refund eligibility and final amounts at its discretion.</p>
            <p>Refund requests must be submitted within a reasonable timeframe, and abuse of the refund system may result in account restrictions.</p>
          </section>

          {/* Service Fee */}
          <section className="terms-section">
            <h2>11. Service Fee</h2>
            <p>Kaddle applies a service fee to transactions conducted on the platform. This fee contributes to operational costs, infrastructure, payment processing, and ongoing platform development.</p>
            <div className="fee-box">
              <p><strong>💳 Tutees pay a 5% service fee on every subscription payment, capped at R30 per subscription.</strong></p>
              <p>This fee helps cover secure payment processing, platform operations, and payment services.</p>
              <p><strong>💰 Tutors can withdraw a minimum of R300 with a R5 withdrawal fee applied.</strong></p>
            </div>
            <p>Fees may be adjusted, capped, or restructured over time. Continued use of the platform constitutes acceptance of any updated fee structure.</p>
          </section>

          {/* Suspension Policies */}
          <section className="terms-section">
            <h2>12. Suspension Policies</h2>
            <p>Kaddle maintains a structured system for handling user violations. Tutees may be suspended based on repeated reports or confirmed misconduct. Tutors may face suspension or removal based on multiple complaints, failure to deliver services, or breaches of platform standards.</p>
            <div className="policy-box">
              <h4>Complaint-Based Review System</h4>
              <p>If three (3) separate complaints are received from three different tutees within a reasonable timeframe:</p>
              <ul>
                <li>The tutor's account may be temporarily suspended for a period of 30 days</li>
                <li>During suspension, the tutor cannot host sessions, receive new subscriptions, or access certain platform features</li>
              </ul>
              <h4>Permanent Suspension</h4>
              <p>After suspension, if the tutor receives three (3) additional complaints from three different tutees, the tutor's account may be permanently banned.</p>
              <h4>Appeals Process</h4>
              <p>A permanently banned tutor may submit a formal appeal to: <strong>support@mykaddle.com</strong></p>
              <p>All appeals are subject to internal review and not guaranteed to result in reinstatement.</p>
            </div>
            <p>Suspension durations, appeal processes, and reinstatement decisions are determined internally. Kaddle reserves full authority over enforcement actions.</p>
          </section>

          {/* Payments and Tutor Wallets */}
          <section className="terms-section">
            <h2>13. Payments and Tutor Wallets</h2>
            <p>All payments on Kaddle are processed through integrated payment systems. Tutor earnings are allocated to an internal wallet and may be subject to holding periods to allow for dispute resolution and fraud prevention.</p>
            <p>Withdrawable balances become available only after the completion of designated holding periods. Kaddle reserves the right to delay, reverse, or withhold payments in cases of suspected fraud, disputes, or policy violations.</p>
            <p>Processing times for withdrawals are estimates and may vary depending on external payment providers. Kaddle is not responsible for delays caused by third-party financial institutions.</p>
          </section>

          {/* Banking Changes */}
          <section className="terms-section">
            <h2>14. Banking Changes and Withdrawal Protection</h2>
            <p>To enhance account security and reduce the risk of fraudulent withdrawals, Kaddle enforces protective measures when banking details are modified. This includes temporary withdrawal restrictions and additional verification steps where necessary.</p>
            <p>Users are responsible for maintaining the confidentiality of their account credentials and banking information. Any unauthorized activity resulting from compromised accounts remains the user's responsibility unless proven otherwise.</p>
            <p>Kaddle reserves the right to impose additional safeguards, including withdrawal limits or extended review periods.</p>
          </section>

          {/* Updates */}
          <section className="terms-section">
            <h2>15. Updates to These Terms</h2>
            <p>Kaddle may update these Terms of Use at any time to reflect changes in platform functionality, legal requirements, or operational practices. Users will be notified of significant updates where appropriate.</p>
            <p>Continued use of the platform after updates constitutes acceptance of the revised terms. Users who do not agree with updated terms should discontinue use of the platform.</p>
          </section>

          {/* Final Agreement */}
          <section className="terms-section final-agreement">
            <h2>Final Agreement</h2>
            <p>By creating an account, accessing, or using Kaddle, users acknowledge that they have read, understood, and agreed to these Terms of Use. These terms constitute a binding agreement between the user and Kaddle.</p>
          </section>

          {/* Contact Section */}
          <section className="terms-section contact-section">
            <h2>Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us:</p>
            <p>📧 <strong>Email:</strong> support@mykaddle.com</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Terms;